import React from "react";
// import HttpService from '../../utils/Http.services';
import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../../components/Configurer";
import ProfileImage from "../../components/partials/ProfileImage";
import TableViewer from "../../components/TableViewer";
// import { v4 as uuidv4 } from 'uuid';
import ItemModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
import RemoveModal from "../../modals/RemoveModal";
import { checkTextTranslation, checkTranslation, pathMaker, phoneStandardView } from "../../utils/useful";
import FilterModal from "../../modals/FilterModal";
import Pagination from "../../components/Pagination";
import OptionsListModal from "../../modals/OptionsListModal";
import Loader from 'react-loader-spinner'
import Modal from "../../components/Modal";
import { saveAs } from 'file-saver';
import DateIndicator from "../../components/DateIndicator";
import moment from "moment";


class CalendarApplet extends React.Component {


    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    state = {
        data: [],
        actions: {
            add: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal },
            edit: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal }
        },
        currentPage: 0,
        limit: 20,
        options: [
            // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
            // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
            // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
            // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        ]
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
    }


    init() {
        if (this.props.page) {
            this.setState({ data: [],calanderData:{}, showCalendar: false, totalCount: null, filters: null }, () => {
                // this.fetchData(true)
                this.setState({ showCalendar: true })
            })
        }
    }

    fetchCalendar = (filter, getCount) => {
        console.log("fetchCalendar")
        this.setState({ isLoadingCalander: true })
        let body = this.props.page.filter ?? {}
        let page = this.props.page
        body.page = page.key
        body.limit = this.state.limit
        body.skip = this.state.currentPage

        body.filter = this.state.filter ?? {}

        if (this.props.page.settings && this.props.page.settings.fetchFilter) {
            body.filter = this.props.page.settings.fetchFilter
        }


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        if (filter) {
            body.filter = { ...body.filter, ...filter }
        }

        // console.log(page.fetchUrl)


        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            this.setState({ isLoadingCalander: false })
            // console.log("DATA")
            if (fetchResult.status == 200) {
                // console.log(data)
                let calanderData = {}

                if (this.props.page.dateKeys) {

                    let startDate = moment(body.filter.date).startOf('month').valueOf()
                    let endDate = moment(body.filter.date).endOf('month').valueOf()

                    this.props.page.dateKeys.forEach(dateKey => {

                        fetchResult.info.forEach(element => {
                            // console.log(dateKey)
                            if (element.values[dateKey] >= startDate && element.values[dateKey] <= endDate) {
                                // console.log(element.values[dateKey])
                                // console.log(element)
                                let day = Number(moment(element.values[dateKey]).format('DD'))

                                // console.log(day)
                                // console.log(element.values.rentalId)
                                if (!calanderData[day]) {
                                    calanderData[day] = []
                                }
                                calanderData[day].push(element)
                            }
                            // console.log(Number(moment(element.values.dueDate).format('DD')))
                        });
                    })
                    // console.log(calanderData)
                    this.setState({ calanderData: [], data: [], showTable: false }, () => {
                        this.setState({
                            calanderData: calanderData
                        })
                    })

                }

            }
        })
    }



    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            // this.fetchData()
        })
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        // console.log(id)
        // console.log(this.props.page.removeUrl)
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            // console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })


        })

    }



    fetchExport = () => {
        // this.setState({ isLoadingRemove: true })
        // let id = this.state.currentItem._id
        HttpServices.request(this.props.page?.extra?.export?.url, {}, (fetchResult, fetchError) => {
            // this.setState({ isLoadingRemove: false })
            // console.log(fetchError)
            // console.log(fetchResult)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            // let data = this.state.data
            // data.splice(this.state.currentIndex, 1)
            // this.setState({ data })
            // console.log(siteConfig.assetsDomain + fetchResult.info)
            saveAs(siteConfig.assetsDomain + fetchResult.info)

            this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })
    }


    itemAdded = (newItem) => {
        // console.log(newItem)
        if (newItem) {
            let data = this.state.data
            data.splice(0, 0, newItem)
            // console.log(newItem)
            // console.log(data)
            this.setState(data)
        } else {
            this.fetchData()
        }
    }

    itemEdited = (editedItem) => {
        // console.log(editedItem)
        let data = this.state.data
        this.state.data.forEach((element, index) => {
            let id = element.id ?? element._id
            let currentId = this.state.currentItem.id ?? this.state.currentItem._id
            if (id === currentId) {
                // console.log(id)
                data[index] = Object.assign({}, editedItem)
            }
        });
        this.setState({ data }, () => {
            // console.log(editedItem)
            // console.log(data)
            // this.TableViewer.forceUpdateData()
        })
    }

    updateData = (data) => {
        this.setState(data)
    }


    openAddNew = () => {
        if (this.props.page?.addNew) {
            let newPage = this.props.page?.addNew
            if (this.props.page?.addNew.includes('../')) {
                newPage = this.props.route + this.props.page?.addNew.replace('..', '')
            }
            // console.log(newPage)
            this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })
        } else {
            this.openEditModal()
        }
    }

    openFilterModal() {
        this.filterModal.showModal()
    }

    doFilter = (data) => {
        // console.log(data)
        this.setState({ currentPage: 0, filter: data }, () => {
            this.fetchData(true)
            this.filterModal.modal.hideModal()

        })
    }

    filterLabelCreator(rawprop) {
        let prop = JSON.parse(JSON.stringify(rawprop))
        // console.log(prop)
        let isArray = false
        if (Array.isArray(prop.value)) {
            isArray = true
        }

        // let label
        let value = prop.value
        if (prop.type == 'PhoneInput') {
            value = phoneStandardView(value)
        }


        if (prop.dictionary) {

            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const element = value[i];
                    if (prop.dictionary[element]) {
                        value[i] = prop.dictionary[element]
                    }
                }
            } else {
                if (prop.dictionary[value]) {
                    value = prop.dictionary[value]
                }
            }
        }

        let label = checkTranslation(prop.label) + ' ' + prop.operator + ' ' + value


        return label
    }

    removeFilter = (prop) => {
        let filter = this.state.filter
        delete filter[prop.key]
        console.log(filter)
        this.setState({ filter }, () => {
            this.fetchData(true)
        })
    }


    openOptions = (prop, index) => {
        // console.log(prop)

        let options = []

        Object.values(this.props.page?.extra).forEach(element => {
            let option = { ...element }
            option.function = this[option.function]
            options.push(option)
        });
        console.log(options)
        // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
        // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
        // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
        // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        // ]

        this.setState({ options, currentItem: prop, currentIndex: index }, () => {
            this.optionsModal.modal.showModal()
        })

    }

    openExport = () => {
        this.exportModal.showModal()
        this.fetchExport()
        // console.log("TEST")
    }

    calanderOnChange = (key, info) => {
        // console.log(info)
        if (info.type == 'changeDate') {
            this.fetchCalendar({ date: info.newDate })
        } else {
            //   console.log(this.state.calanderData[info.dayNumber] )
            this.setState({ showTable: false, data: [] }, () => {
                this.setState({ showTable: true, data: this.state.calanderData[info.dayNumber] })
            })
        }

    }

    render() {
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation(this.props.page?.title), button: { goBack: false } }}
                title={checkTextTranslation(this.props.page?.title)}
                description={checkTextTranslation(this.props.page?.description)}
                className=""
            >

                <div className="container " >
                    <div className="row m-0">
                        <div className="col-12 p-0 mb-4" >
                            <div className="p-0" style={{ borderRadius: 0 }}>

                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                    <div className="flexc mt-2">

                                        <ProfileImage width={54} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image ?? this.props.page?.icon }} />

                                        <div>
                                            <p className="text-big font-bold m-0 " style={{ color: '#0d172a' }}>{this.props.page?.title}</p>
                                            <p className="text-small m-0" style={{ color: '#89a' }} >{this.state.totalCount ? (this.state.totalCount + " Records Found") : this.props.page?.description}</p>
                                        </div>
                                    </div>



                                </div>


                                {this.state.filter && Object.values(this.state.filter).length > 0 && (
                                    <div className="flexc mt-2 px-1">
                                        {Object.values(this.state.filter).map((prop, index) => {
                                            return (
                                                <div key={index} className="flexcc mrd-1" style={{ backgroundColor: 'rgba(103, 125, 196, 0.082)', color: 'rgba(103, 125, 196, 0.8)', borderRadius: 20, padding: '3px 10px', fontSize: 12, }}>
                                                    {this.filterLabelCreator(prop)}
                                                    <button onClick={() => this.removeFilter(prop)} className="p-0 mld-2" style={{ color: 'rgba(103, 125, 196, 0.8)', fontSize: 12 }}>
                                                        <span className="flexcc">X</span>
                                                    </button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}

                            </div>

                        </div>

                        {this.state.showCalendar && (
                            <DateIndicator data={this.state.calanderData} isLoading={this.state.isLoadingCalander} header={{ information: {} }} onChange={this.calanderOnChange} />
                        )}


                        <div className="col-12 mb-5 mt-4 w-100 p-0">
                            <TableViewer
                                isLoading={this.state.isLoadingData}
                                headers={this.props.page?.headers}
                                data={this.state.data}
                                // actions={this.state.actions}
                                settings={{ isSortable: false }}
                                openEditModal={this.openEditModal}
                                openRemoveModal={this.openRemoveModal}
                                updateData={this.updateData}
                                ref={el => this.TableViewer = el}
                            />


                            <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />

                        </div>


                    </div>



                    <FilterModal
                        ref={el => this.filterModal = el}
                        initData={this.state.filter}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        doFilter={this.doFilter} />


                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        initData={this.state.currentItem}
                        variables={this.props.variables}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                        showDates={true}
                    />


                    <RemoveModal
                        isLoading={this.state.isLoadingRemove}
                        removeFunction={this.fetchRemove}
                        ref={el => this.removeModal = el}
                    />

                    <OptionsListModal ref={el => this.optionsModal = el}
                        options={this.state.options}
                    />

                    <Modal ref={el => this.exportModal = el} maxWidth={300}>
                        <div className="pb-5 w-100 h-100">
                            <div className="w-100 h-100" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
                                <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

                                    <p className="text-bold mb-0 text-normal ">Export</p>

                                    <div className="cursor-pointer" onClick={() => this.optionsModal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                    </div>

                                </div>
                                <div className="py-4 px-3 pb-2 w-100 text-center">
                                    <Loader
                                        type="Oval"
                                        color="#789"
                                        height="50"
                                        width="50"
                                    />
                                    <p>Exporting in process ...</p>
                                    <p className="text-smaller" style={{ color: '#789' }}>Wait till it is completed</p>

                                </div>

                            </div>
                        </div>

                    </Modal>

                </div>
            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CalendarApplet);
